/** Detección gym virtual (padre) vs sede hija vs holding en el shell del dashboard. */
import gymRoles from '../../shared/gym-role-constants.json';

export function userRoleList(user) {
  return user?.roles?.length ? user.roles : [user?.rol].filter(Boolean);
}

export function getUserCompanyId(user) {
  const v = user?.company_id ?? user?.companyId ?? null;
  return v != null ? Number(v) : null;
}

export function getUserGymId(user) {
  const v = user?.gym_id ?? user?.gymId ?? null;
  return v != null ? Number(v) : null;
}

/** admin_marca del holding: sin gym_id y sin roles operativos de gym/sede. */
export function isHoldingMarcaAdmin(user) {
  if (!user) return false;
  const roles = userRoleList(user);
  if (!roles.includes(gymRoles.holdingMarcaRole)) return false;
  if (roles.some((r) => gymRoles.gymVirtualStaffRoles.includes(r) || r === gymRoles.sedeOperatorRole)) {
    return false;
  }
  return getUserGymId(user) == null;
}

export function hasSedeRole(user) {
  return userRoleList(user).includes(gymRoles.sedeOperatorRole);
}

export function hasGymParentRole(user) {
  if (isHoldingMarcaAdmin(user)) return false;
  return userRoleList(user).some((r) => gymRoles.frontendGymParentCheckRoles.includes(r));
}

/** Admin operativo de sede hija. */
export function isSedeOperatorUser(user, gym = null) {
  if (!user) return false;
  if (hasSedeRole(user)) return true;
  if (hasGymParentRole(user)) return false;
  if (!userRoleList(user).includes('admin_gimnasio')) return false;
  return Boolean(gym?.parent_gym_id);
}

/** Admin del gimnasio virtual padre (no sede, no holding). */
export function isGymVirtualOperatorUser(user, gym = null) {
  if (!user) return false;
  if (isHoldingMarcaAdmin(user)) return false;
  if (isSedeOperatorUser(user, gym)) return false;
  if (!userRoleList(user).some((r) => gymRoles.frontendGymVirtualCheckRoles.includes(r))) {
    return false;
  }
  if (gym?.parent_gym_id && !hasGymParentRole(user)) return false;
  return true;
}

export function canCreateChildSedesUser(user, scopeGym = null) {
  if (!user || isHoldingMarcaAdmin(user)) return false;
  if (isSedeOperatorUser(user, scopeGym)) return false;
  if (userRoleList(user).includes('admin_d28d') && scopeGym && !scopeGym.parent_gym_id) {
    return true;
  }
  return hasGymParentRole(user);
}

/** Rol explícito de consumidor en sede hija. */
export function hasSedeFinalRole(user) {
  return userRoleList(user).includes(gymRoles.finalSedeRole);
}

/** Usuario final de sede: solo gym virtual (programas activados), sin catálogo D28D plataforma. */
export function isSedeFinalUser(user, gym = null) {
  if (!user) return false;
  // Training independiente: cliente de coach (incluso con module_access recortado en pendiente).
  const trainerId = user.trainer_id ?? user.trainerId ?? user.coach_branding?.id ?? null;
  const gymId = user.gym_id ?? user.gymId ?? null;
  const ma = user.module_access || {};
  if (trainerId != null && gymId == null) return false;
  if (
    trainerId != null
    && ma.d28d !== true
    && ma.live_classes !== true
  ) {
    return false;
  }
  const operatorRoles = gymRoles.sedeFinalOperatorExcludes;
  if (userRoleList(user).some((r) => operatorRoles.includes(r))) return false;
  if (hasSedeFinalRole(user)) return true;
  if (user.is_sede_final === true) return true;
  const parentId = gym?.parent_gym_id ?? user?.gym_parent_id ?? null;
  if (parentId != null) return true;
  return false;
}
